import React from "react";

/**
 * CredibilityStrip — small "As seen on" strip for E-E-A-T proof.
 * Used on Homepage Hero + About page. Mirrors the Person schema credentials
 * so Google sees on-page proof alongside structured data.
 *
 * Props:
 *   - variant: "light" (cream bg pages) | "dark" (teal section bg)
 *   - compact: smaller spacing for hero placement
 */
export const CredibilityStrip = ({ variant = "light", compact = false }) => {
  const items = [
    "KKNW Seattle",
    "KING 5",
    "CBS East Coast",
    "The Oscars",
    "Huffington Post",
    "HeartMath Certified",
  ];

  const isDark = variant === "dark";
  const kickerColor = isDark ? "#5EEAD4" : "#25a1c2";
  const itemColor = isDark ? "rgba(255,255,255,0.85)" : "#068fa2";
  const dividerColor = isDark ? "rgba(94, 234, 212, 0.35)" : "rgba(37, 161, 194, 0.35)";

  return (
    <div
      data-testid="credibility-strip"
      className={compact ? "py-3" : "py-5"}
      aria-label="Featured in and certified by"
    >
      <p
        className="font-sans text-[10px] sm:text-[11px] tracking-[0.3em] uppercase font-medium mb-3"
        style={{ color: kickerColor }}
      >
        As Featured On &nbsp;·&nbsp; Certified By
      </p>
      <div
        className="flex flex-wrap items-center gap-x-4 gap-y-2"
        style={{ color: itemColor }}
      >
        {items.map((item, i) => (
          <React.Fragment key={item}>
            <span
              className="font-serif text-sm sm:text-base italic tracking-wide"
              data-testid={`credibility-item-${i}`}
            >
              {item}
            </span>
            {i < items.length - 1 && (
              <span
                aria-hidden="true"
                className="text-xs"
                style={{ color: dividerColor }}
              >
                ✦
              </span>
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default CredibilityStrip;
